if($('.in-registrace').length){
    if(sessionStorage.registrationSection) {
        $('#content-wrapper .content-wrapper-in').prepend(sessionStorage.registrationSection);
    } else {
        $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/vyhody-registrace/",
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find('div[itemprop="about"]').html();
                null !== t && ($('.content-wrapper-in').prepend('<div class="registrationText"><div class="innerText">'+t+'</div></div>'))
                sessionStorage.registrationSection = '<div class="registrationText"><div class="innerText">'+t+'</div></div>';
                }
            });
    }
}